import {
  FETCH_BEEF_BODIES_REQUEST,
  FETCH_BEEF_BODIES_SUCCESS,
  FETCH_BEEF_BODIES_FAILURE,
  CREATE_BEEF_BODY_REQUEST,
  CREATE_BEEF_BODY_SUCCESS,
  CREATE_BEEF_BODY_FAILURE,
} from "../actions/beef_bodies";

const initialState = {
  beefBody: [],
  loading: false,
  error: null,
};

const beefBodyReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_BEEF_BODY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_BEEF_BODY_SUCCESS:
      return {
        ...state,
        beefBody: [...state.beefBody, ...action.payload],
        loading: false,
      };
    case CREATE_BEEF_BODY_FAILURE:
      return {
        ...state,
        loading: false,
        beefBody: "",
        beefBodyDetails: "",
        error: action.payload,
      };
    case FETCH_BEEF_BODIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_BEEF_BODIES_SUCCESS:
      return {
        ...state,
        loading: false,
        beefBody: action.payload,
      };
    case FETCH_BEEF_BODIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default beefBodyReducer;
